"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_utils_1 = require("@zapier/common-utils");
const react_1 = require("react");
const core_1 = require("@emotion/core");
const design_system_1 = require("@zapier/design-system");
const lodash_1 = require("lodash");
const itemCss = (isSelected) => core_1.css `
  padding: 10px;
  background-color: ${isSelected ? design_system_1.Colors.grey100 : 'inherit'};
  color: ${design_system_1.Colors.black};
  border-radius: 10px;
  &:hover,
  &:focus {
    background-color: ${design_system_1.Colors.blue100};
    cursor: pointer;
  }
`;
const itemHeaderCss = core_1.css `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
function EventPickerEventPickerFloatingMenuItem({ isSelected, service, }) {
    return (common_utils_1.isolateComponent("div", { css: itemCss(isSelected) },
        common_utils_1.isolateComponent("div", { css: itemHeaderCss },
            common_utils_1.isolateComponent(design_system_1.Text, { fontWeight: 600, type: "altText900" }, service.label),
            service.instant && (common_utils_1.isolateComponent(design_system_1.TagLabel, { color: "dark", size: "small" }, "instant"))),
        common_utils_1.isolateComponent("div", null,
            common_utils_1.isolateComponent(design_system_1.Text, { color: "grey700", type: "altText800" }, service.helpText))));
}
const containerCss = core_1.css `
  max-height: 400px;
  overflow-y: auto;
`;
const groupHeaderCss = core_1.css `
  margin: 0px 20px;
  padding-top: 10px;
  &:not(:first-of-type) {
    border-top: 1px solid ${design_system_1.Colors.grey200};
  }
`;
const groupContentCss = core_1.css `
  padding: 0px 10px 10px;
`;
function EventPickerFloatingMenu({ groups, getItemProps, selectedItem, }) {
    return (common_utils_1.isolateComponent(design_system_1.FloatingBox, { align: "stretch", minWidth: "400px", position: "south" },
        common_utils_1.isolateComponent("div", { css: containerCss }, lodash_1.map(groups, group => (common_utils_1.isolateComponent(react_1.Fragment, { key: group.itemType },
            common_utils_1.isolateComponent("div", { css: groupHeaderCss },
                common_utils_1.isolateComponent(design_system_1.Text, { color: "grey500", type: "allCaps800" }, group.header)),
            common_utils_1.isolateComponent("div", { css: groupContentCss }, lodash_1.map(group.items, item => (common_utils_1.isolateComponent("div", Object.assign({ key: item.itemKey }, getItemProps({ item })),
                common_utils_1.isolateComponent(EventPickerEventPickerFloatingMenuItem, { isSelected: item === selectedItem, service: item })))))))))));
}
exports.default = EventPickerFloatingMenu;
